import ADS_PLATFORMS from '../constants/AdsPlatformsConstants';
import { FACEBOOK_ADS_METRICS, GOOGLE_ADS_METRICS, CLIENT_METRICS } from '../constants/MetricsTypeConstants';
import { formatValuesForDisplayBasedOnType } from './strings';

export const getMetricsByAccountType = ({
    [ADS_PLATFORMS.GOOGLE_ADS]: GOOGLE_ADS_METRICS,
    [ADS_PLATFORMS.FACEBOOK_ADS]: FACEBOOK_ADS_METRICS,
    [ADS_PLATFORMS.CLIENT]: CLIENT_METRICS,
});

export const getMetricViewProps = ({ total = 0, metric = '' } = {}, config) => {
    const isNaN = Number.isNaN(total);
    const metricKey = metric.toLowerCase().replace(/ /g, '_');
    const { label = '', type = '' } = config[metricKey] || {};
    const value = isNaN ? null : formatValuesForDisplayBasedOnType(total, type);

    return {
        label,
        value,
    };
};
